import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { scrollToId } from "@/lib/scroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ToolsGrid } from "@/components/ToolsGrid";
import { Calculator } from "@/components/Calculator";
import { Manifesto } from "@/components/Manifesto";
import { CtaBanner } from "@/components/CtaBanner";
import { Footer } from "@/components/Footer";
import AvisoLegal from "@/pages/AvisoLegal";
import PoliticaPrivacidad from "@/pages/PoliticaPrivacidad";
import GuiaInversion from "@/pages/GuiaInversion";

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const t = setTimeout(() => scrollToId(window.location.hash), 700);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <main>
      <Hero />
      <Marquee />
      <ToolsGrid />
      <Calculator />
      <Manifesto />
      <CtaBanner />
    </main>
  );
};

function App() {
  useLenis();

  return (
    <BrowserRouter>
      <div className="min-h-screen overflow-x-clip bg-[#F8FAFC] font-sans text-slate-900 antialiased">
        <Toaster position="top-center" richColors />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/guia-inversion-inmobiliaria" element={<GuiaInversion />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
